import React from 'react';
import { Skeleton } from '@gov-nx/component/web';
import { ContentLayout, LayoutGap } from '@gov-nx/ui/web';
import { generateRandomNumber } from '@gov-nx/utils/common';

export const GunListSkeleton = () => (
	<ContentLayout>
		<LayoutGap gap="l">
			<Skeleton
				width="270px"
				height="28px"
			/>
			<Skeleton
				width="80%"
				height="22px"
			/>
			<div>
				<LayoutGap
					gap="s"
					className="p-6">
					<Skeleton
						width={generateRandomNumber(20, 60) + '%'}
						height="26px"
					/>
					<Skeleton
						width="75%"
						height="22px"
					/>
					<Skeleton
						width={generateRandomNumber(80, 100) + '%'}
						height="22px"
					/>
					<Skeleton
						width={generateRandomNumber(40, 100) + '%'}
						height="22px"
					/>
				</LayoutGap>
			</div>
		</LayoutGap>
	</ContentLayout>
);
